'use client'
import { Toaster } from 'ui/sonner'
import { ProgressProvider } from '@bprogress/next/app'
import { getQueryClient } from '~/utils/get-query-client'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { MathJaxProvider } from '~/components/miscellaneous/mathjax-context'

export function Providers({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ProgressProvider
        style="style"
        options={{ showSpinner: false }}
        shallowRouting
      >
        <MathJaxProvider>{children}</MathJaxProvider>
      </ProgressProvider>
      <ReactQueryDevtools
        initialIsOpen={false}
        position="left"
        buttonPosition="top-left"
      />
      <Toaster richColors />
    </QueryClientProvider>
  );
}
